/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import {
  Paper, Box, Typography, Grid,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Input from '../../../components/input';
import ButtonTemplate from '../../../components/Button/Button';
import { VerificarEmailExistenteAPI } from '../../../services/loginAPI';
import { LoginStore } from '../../../services/zustandProvider';
import { TermoConsentimento, TermoConsentimentoUseState } from './Components/TermoConsentimento';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#4c5c68 !important',
    padding: 30,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  ou: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: 'white',
    width: 150,
    height: 6,
    marginTop: 30,
    marginBottom: 30,
  },
}));

interface propsType {
  emailContato: string;
};

export default function Cadastro({
  emailContato,
}: propsType):JSX.Element {
  const history = useHistory();
  const [errorEmail, setErrorEmail] = useState({
    status: false,
    massage: '',
  });
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const termoConsentimentoState = TermoConsentimentoUseState();

  async function Verificar() {
    setLoading(true);
    const verificacao = await VerificarEmailExistenteAPI(email);
    if (verificacao.sucesso) {
      setErrorEmail({ status: false, massage: '' });
      termoConsentimentoState.open();
    } else if (verificacao.erros[0].propertyName === 'Email') {
      console.log('EmailSenha');
      setErrorEmail({ status: true, massage: verificacao.erros[0].errorMessage });
    } else {
      console.log('consexão');
      setErrorEmail({ status: true, massage: verificacao.erros[0].errorMessage });
    }
    setLoading(false);
  };
  return (
    <>
      <TermoConsentimento
        open={termoConsentimentoState.status}
        handleClose={termoConsentimentoState.close}
        emailContato={emailContato}
        emailUsuario={email}
      />

      <Box sx={{ width: '100%' }}>
        <Input
          id="E-mail"
          labelSuperior="E-mail"
          name="E-mail"
          placeHolder="E-mail"
          inputColor="white"
          autoFocus
          variant="outlined"
          error={errorEmail.status}
          mensagem={errorEmail.massage}
          value={email}
          onChange={((e: any) => setEmail(e.target.value))}
        />
        <Box sx={{ textAlign: 'center' }}>
          <ButtonTemplate
            style={{ marginLeft: 'auto', marginRight: 'auto' }}
            cor="cyan"
            tonalidade={800}
            className={classes.submit}
            size="large"
            variante="loading"
            loading={loading}
            onClickLoading={() => Verificar()}
          >
            Cadastre-se
          </ButtonTemplate>
        </Box>
      </Box>
    </>
  );
}
